<div class="card new-card" [ngClass]="{'mt-4' : vehicle.images?.length < 1,
                                       'm-0': vehicle.images?.length > 0}">   
    <app-card-title [title]="'Informações'" icon="app-icon-in-stock"></app-card-title>
    <div class="info-container">
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    palette
                </span>
                <span class="label">Cor</span>
            </div>
            <span class="value">{{ColorLabel[vehicle.color]}}</span>
        </div>
        <div class="info" *ngIf="isTruck">
            <div class="label-container">
                <span class="material-icons icon">
                    settings
                </span>
                <span class="label">Tração</span>
            </div>
            <span class="value">{{vehicle.truckTractionLabel}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    key
                </span>
                <span class="label">Chave reserva</span>
            </div>
            <span class="value">{{vehicle.extraKey == undefined ? '-' : vehicle.extraKey ? 'Sim' : 'Não'}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    bolt
                </span>
                <span class="label">Potência</span>
            </div>
            <span class="value">{{vehicle.power ? (vehicle.power + 'cv') : '-'}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    menu_book
                </span>
                <span class="label">Manual do proprietário</span>
            </div>
            <span class="value">{{vehicle.carManual == undefined ? '-' : vehicle.carManual ? 'Sim' : 'Não'}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    group
                </span>
                <span class="label">Passageiros</span>
            </div>
            <span class="value">{{vehicle.passengers || '-'}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    rv_hookup
                </span>
                <span class="label">Carroceria</span>
            </div>
            <span class="value">{{vehicle.bodywork || '-'}}</span>
        </div>
        <div class="info" *ngIf="isTruck">
            <div class="label-container">
                <span class="material-icons icon">
                    height
                </span>
                <span class="label">Aplicação</span>
            </div>
            <span class="value">{{vehicle.truckTypeLabel || '-'}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    123
                </span>
                <span class="label">Chassis</span>
            </div>
            <span class="value">{{vehicle.chassis}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    abc
                </span>
                <span class="label">renavam</span>
            </div>
            <span class="value">{{vehicle.renavam}}</span>
        </div>
        <div class="info" *ngIf="isTruck">
            <div class="label-container">
                <span class="material-icons icon">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"
                        fill="#16b097">
                        <path
                            d="M156-144q-45 0-76.5-31.48T48-251.92Q48-287 68-315t52-39v-252q-32-11-52-38.92t-20-63.05Q48-753 79.5-784.5T156-816q45 0 76.5 31.48t31.5 76.44Q264-673 244-645t-52 39v90h228v-90q-32-11-52-38.92t-20-63.05q0-45.03 31.5-76.53T456-816q45 0 76.5 31.48t31.5 76.44Q564-673 544-645t-52 39v90h192q15.3 0 25.65-10.35Q720-536.7 720-552v-54q-32-11-52-38.92t-20-63.05q0-45.03 31.5-76.53T756-816q45 0 76.5 31.48t31.5 76.44Q864-673 844-645t-52 39v54q0 45-31.5 76.5T684-444H492v90q32 11 52 38.92t20 63.05q0 45.03-31.5 76.53T456-144q-45 0-76.5-31.48T348-251.92Q348-287 368-315t52-39v-90H192v90q32 11 52 38.92t20 63.05q0 45.03-31.5 76.53T156-144Zm-.21-72q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm0-456q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm300 456q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm0-456q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm300 0q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM156-252Zm0-456Zm300 456Zm0-456Zm300 0Z" />
                    </svg>
                </span>
                <span class="label">Marchas</span>
            </div>
            <span class="value">{{vehicle.gearsSize || '-'}}</span>
        </div>
        <div class="info" *ngIf="isTruck">
            <div class="label-container">
                <span class="material-icons icon">
                    local_shipping
                </span>
                <span class="label">Classificação</span>
            </div>
            <span class="value">{{vehicle.truckClassificationLabel || '-'}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    airline_seat_recline_normal
                </span>
                <span class="label">{{isTruck ? 'Caixa de transmissão' : 'Câmbio'}}</span>
            </div>
            <span class="value">{{vehicle.transmissionLabel || '-'}}</span>
        </div>
        <div class="info" *ngIf="isTruck">
            <div class="label-container">
                <span class="material-icons icon">
                    category
                </span>
                <span class="label">Implemento - tipo</span>
            </div>
            <span class="value">{{vehicle.implement?.typeLabel || '-'}}</span>
        </div>
        <div class="info">
            <div class="label-container">
                <span class="material-icons icon">
                    public
                </span>
                <span class="label">Origem</span>
            </div>
            <span class="value">{{CountryLabel[vehicle.countryOrigin] || '-'}}</span>
        </div>
        <div class="info" *ngIf="isTruck">
            <div class="label-container">
                <span class="material-icons icon">
                    category
                </span>
                <span class="label">Implemento - Fabricante</span>
            </div>
            <span class="value">{{vehicle.implement?.makeName || '-'}}</span>
        </div>
        <div class="info" *ngIf="isTruck">
            <div class="label-container">
                <span class="material-icons icon">
                    local_gas_station
                </span>
                <span class="label">Tanque (L)</span>
            </div>
            <span class="value">{{vehicle.tankSize || '-'}}</span>
        </div>
    </div>
</div>